import { render, staticRenderFns } from "./wxhealthyheader.vue?vue&type=template&id=74268c00&scoped=true&"
import script from "./wxhealthyheader.vue?vue&type=script&lang=js&"
export * from "./wxhealthyheader.vue?vue&type=script&lang=js&"
import style0 from "./wxhealthyheader.vue?vue&type=style&index=0&id=74268c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74268c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74268c00')) {
      api.createRecord('74268c00', component.options)
    } else {
      api.reload('74268c00', component.options)
    }
    module.hot.accept("./wxhealthyheader.vue?vue&type=template&id=74268c00&scoped=true&", function () {
      api.rerender('74268c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxhealthyheader.vue"
export default component.exports